import { Controller } from "@hotwired/stimulus"

// Light/dark theme toggle for the API docs page.
// - Reads stored preference from localStorage ("ccs-api-docs-theme": "dark" | "light").
// - Falls back to prefers-color-scheme on first visit.
// - Toggles the `dark` class on <html>.
const STORAGE_KEY = "ccs-api-docs-theme"

export default class extends Controller {
  static targets = ["sunIcon", "moonIcon"]

  connect() {
    this.applyTheme(this.currentTheme())
  }

  toggle() {
    const next = document.documentElement.classList.contains("dark") ? "light" : "dark"
    localStorage.setItem(STORAGE_KEY, next)
    this.applyTheme(next)
  }

  currentTheme() {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored === "dark" || stored === "light") return stored
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"
  }

  applyTheme(theme) {
    document.documentElement.classList.toggle("dark", theme === "dark")
    if (this.hasSunIconTarget) this.sunIconTarget.classList.toggle("hidden", theme === "dark")
    if (this.hasMoonIconTarget) this.moonIconTarget.classList.toggle("hidden", theme !== "dark")
  }
}
